import { Injectable } from '@angular/core';
import { HandleError, HttpErrorHandlerService } from './http-error-handler.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { MyModule } from '../model/my-module';
import { APIFactoryEndPoints } from '../common/apifactory-end-points';
import { catchError } from 'rxjs/operators';
import { Company } from '../model/company';
import { User } from '../model/user';
//import { ParentLocation } from '../model/parent-location';
import { Location } from '../model/location';
import { ViewReport } from '../model/viewreport';
import { Observable, of } from 'rxjs';
import { InventoryType } from '../model/FacilityManager/inventory-type';
import { ProductMatrix } from '../model/FacilityManager/product-matrix';
import { ProductGroup } from '../model/FacilityManager/product-group';
import { ProductSubGroup } from '../model/FacilityManager/product-sub-group';
import { ProductDetails } from '../model/FacilityManager/product-details';
import { SummaryReport } from '../model/summary-report';
import { RouteList } from '../model/route-list';
import { CustomerClass } from '../model/customer-class';
import { SummaryReportSale } from '../model/summary-report-sale';
import { Organiser } from '../model/organiser';
import { OrganiserDetail } from '../model/organiser-detail';
import { SummaryMaketoOrder } from '../model/summary-maketo-order';
import { SummaryInventoryReport } from '../model/summary-inventory-report';
import { Department } from '../model/AssetSetUp/department';
import { SummaryProduction } from '../model/summary-production';
import { Employee } from '../model/employee';
import { VisitorAppointment } from '../model/Security/Visitor/visitorappointment';
import { VisitorVisit } from '../model/Security/Visitor/visitorvisit';
import { Supplier } from '../model/supplier';
import { SummaryPurchase } from '../model/summary-purchase';
import { Customer } from '../model/Collection/customer';
import { getGSTReportsParam } from '../model/get-gst-reports-param';
import { ProductDetailsMakeYourCake } from '../model/Master/Product/Product-Details-Make-Your-Cake';
import { ProductColors } from '../model/Master/Others/product-color';
import { ProductComposition } from '../model/Master/Composition/product-composition';
import { ProductShape } from '../model/Master/Others/product-shape';
import { AssetsName } from '../model/AssetManager/assetsName';
import { ViewByLocIdFromDateToDate } from '../model/RequestView/viewByLocIdFromDateToDate';
import { ParentLocation } from '../model/Master/Location/parentLocation';
import { SubModule } from '../model/sub-module';
import { SubSubModule } from '../model/sub-sub-module';
import { UserGroup } from '../model/Settings/Admin/user-group';
import { ProductDetail } from '../model/Master/Product/product-detail';
import { RequestView } from 'src/app/model/OrderManagement/OrderStock/RewMaterials/RequestView/request-view';
import { Designation } from '../model/Master/Designation/designation';
import { ErrorLog } from '../model/Common/error-log';
import { AllModule } from '../model/AllModule';
import { SummaryReportGst } from '../model/summary-report-gst';
import { SummaryFestivalCouponReport } from '../model/Reports/SummaryReport/summary-festival-coupon-report';
import { DetailStoreReporting } from '../model/Reports/StoreReporting/detail-store-reporting';
import { AbstractControl, UntypedFormGroup } from '@angular/forms';
import { WebOrderStoreSetup } from '../model/web-order-store-setup';
import { WebOrderAllowProductDto } from '../model/web-order-allow-product-dto';
import { SummaryHrReport } from '../model/summary-hr-report';
import { SubscriptionPlan } from '../model/Subscription/subscription-plan';

@Injectable({
  providedIn: 'root'
})
export class MainContainerService {


  getCreateViewEditCancelPermissions(subSubGroupId: number) {
    return this.http.get<any>(this.apiURL.getCreateViewEditCancelPermissions + "/" + subSubGroupId)
      .pipe(
        catchError(this.handleError('subSubGroupId', "SORRY"))
      );
  }
  getModuleWisePermissions(url: string, userId: string) {
    return this.http.get<any>(url + "/" + userId)
      .pipe(
        catchError(this.handleError('getImage', "No Module Permissions"))
      );
  }


  private handleError: HandleError;

  constructor(
    private http: HttpClient,
    private apiURL: APIFactoryEndPoints,
    httpErrorHandler: HttpErrorHandlerService
  ) {
    this.handleError = httpErrorHandler.createHandleError('MainContainerService');
  }
  getImage(url: string, img: String): any {

    return this.http.get<any>(url + img, { responseType: 'arraybuffer' as 'json' })
      .pipe(
        catchError(this.handleError('getImage', "SORRY"))
      );
  }

  //For export
  exportViewData(url: string, exportType: string, module: string, req: any) {
    return this.http.post(url + "/" + exportType + "/" + module, req, { responseType: 'arraybuffer' }).pipe(
      catchError(this.handleError('exportViewData()', []))
    );
  }

  //new added
  getAllCompaniesByUser() {
    return this.http.get<Company[]>(this.apiURL.getAllCompaniesByUser)
      .pipe(
        catchError(this.handleError('getAllCompaniesByUser()', []))
      );
  }
  setLoginTimeOfUser() {
    return this.http.get<any[]>(this.apiURL.setLoginTimeOfUser)
      .pipe(
        catchError(this.handleError('getAllCompaniesByUser()', []))
      );
  }
  getParentLocationsByUser() {
    return this.http.get<Location[]>(this.apiURL.getParentLocationsByUser)
      .pipe(
        catchError(err => this.handleErrorNew('getParentLocationsByUser', err, []))
      );
  }
  private handleErrorNew<T>(operation = 'operation', error?: any, result?: T) {
    let status = error?.status ?? 'unknown';
    let statusText = error?.statusText ?? 'unknown';
    let message = error?.message ?? (error?.toString() ?? 'unknown');
    let url = error?.url ?? 'unknown';

    // Extract server error payload (body)
    let errorPayload = error?.error ?? null;       // The server's JSON/body
    let errorBody = error?.error?.body ?? null; // If server wraps inside "body"

    // Extract request object info
    let reqMethod = error?.error?.method ?? null;
    let reqPayload = error?.error?.params ?? null;

    console.error(`Http error occurred in :: ${operation}():`);
    console.error(`➡️ Status: ${status}`);
    console.error(`➡️ Status Text: ${statusText}`);
    console.error(`➡️ Message: ${message}`);
    console.error(`➡️ URL: ${url}`);

    console.error(`➡️ Error Payload (error.error):`, errorPayload);
    console.error(`➡️ Error Body (error.error.body):`, errorBody);
    console.error(`➡️ Request Method:`, reqMethod);
    console.error(`➡️ Request Payload / Params:`, reqPayload);

    console.error(`➡️ Full HttpErrorResponse object:`, error);

    // Return safe fallback value so app doesn't crash
    return of(result as T);
  }

  getLocationsByUserAndParentLocIdOrRefNoAndCompanyCode(parentLocId: number, companyCode: number) {
    return this.http.get<Location[]>(this.apiURL.getLocationsByUserAndParentLocIdOrRefNoAndCompanyCode + "/" + parentLocId + "/" + companyCode)
      .pipe(
        catchError(this.handleError('getLocationsByUserAndParentLocIdOrRefNoAndCompanyCode()', []))
      );
  }

  getProductGroupByMatrixCode(url: string, matrixCode: number) {
    return this.http.get<ProductGroup[]>(url + '/' + matrixCode)
  }

  getProductSubGroupByGroupCode(url: string, productGroupCode: number) {
    return this.http.get<any>(url + '/' + productGroupCode)
      .pipe(
        catchError(this.handleError('getProductSubGroupByGroupCode()', []))
      );
  }

  getProductDetailsBySubGroupCodes(url: string, subGroupId: number[]) {
    return this.http.get<any>(url + '/' + subGroupId)
      .pipe(
        catchError(this.handleError('getProductDetailsBySubGroupCode()', []))
      );
  }
  getProductDetailsBySubGroupCode(url: string, subGroupId: number) {
    return this.http.get<any>(url + '/' + subGroupId)
      .pipe(
        catchError(this.handleError('getProductDetailsBySubGroupCode()', []))
      );
  }
  getPackageSetupByProductCode(url: string, productId: number) {
    return this.http.get<any>(url + '/' + productId)
      .pipe(
        catchError(this.handleError('getProductDetailsBySubGroupCode()', []))
      );
  }
  getParentLocationByChildLocCode(childLocCode: number) {
    return this.http.get<ParentLocation>(this.apiURL.getParentLocationByChildLocCode + "/" + childLocCode)
      .pipe(
        catchError(this.handleError('getParentLocationByChildLocCode()', []))
      );
  }
  getAllWebModules(locId: number) {
    return this.http.get<AllModule[]>(this.apiURL.getAllWebModule + "/" + locId)

  }

  getAllModules() {
    return this.http.get<MyModule[]>(this.apiURL.getAllModule)

  }
  getSubModulesByModule(moduleId: number) {
    return this.http.get<SubModule[]>(this.apiURL.getSubModulesByModule + moduleId)
      .pipe(
        catchError(this.handleError('getSubModulesByModule()', []))
      );
  }
  getSubSubModulesBySubModule(subModuleId: number) {
    console.log("service" + subModuleId);
    let data = this.http.get<SubSubModule[]>(this.apiURL.getSubSubModulesBySubModule + subModuleId)
      .pipe(
        catchError(this.handleError('getSubSubModulesBySubModule()', []))
      );
    console.log("data====>>>>" + data);
    return data;
  }

  getAllUser() {
    return this.http.get<User[]>(this.apiURL.getAllUser)
      .pipe(
        catchError(this.handleError('getAllUser()', []))
      );
  }
  getModules() {
    return this.http.get<MyModule[]>(this.apiURL.getModules).pipe(
      catchError(this.handleError('getAllCompany()', []))
    );
  }
  getModulesForEditTrail() {
    return this.http.get<MyModule[]>(this.apiURL.getModulesForEditTrail).pipe(
      catchError(this.handleError('getModulesForEditTrail()', []))
    );
  }
  getSubModules(mod: number) {
    let url = this.apiURL.getSubModules
    if (mod != 0)
      url = this.apiURL.getSubModules + "/" + mod
    return this.http.get<SubModule[]>(url).pipe(
      catchError(this.handleError('getAllCompany()', []))
    );
  }
  getSubSubModules(smod: number[]) {
    // let url = this.apiURL.getSubSubModules

    let url = this.apiURL.getSubSubModules + "/" + smod
    return this.http.get<SubSubModule[]>(url).pipe(
      catchError(this.handleError('getAllCompany()', []))
    );
  }
  getAllEmployee() {
    return this.http.get<Employee[]>(this.apiURL.getEmployees)
      .pipe(
        catchError(this.handleError('getAllEmployee()', []))
      );
  }
  getAllSupplier() {
    return this.http.get<Supplier[]>(this.apiURL.viewSupplierList)
      .pipe(
        catchError(this.handleError('getAllSupplier()', []))
      );
  }

  getAllMatrixs() {
    return this.http.get<ProductMatrix[]>(this.apiURL.getMatrixs)
      .pipe(
        catchError(this.handleError('getAllMatrixs()', []))
      );
  }
  getAllDesignations() {
    return this.http.get<Designation[]>(this.apiURL.getDesignations)
      .pipe(
        catchError(this.handleError('getAllDesignations()', []))
      );
  }
  getAllDepartment() {
    return this.http.get<Department[]>(this.apiURL.viewDepartmentList)
      .pipe(
        catchError(this.handleError('getAllDepartment()', []))
      );
  }
  getAllGroups() {
    return this.http.get<UserGroup[]>(this.apiURL.getAllGroups)
    // .pipe(
    //   catchError(this.handleError('getAllGroups()', []))
    // );
  }
  getAllCompany() {
    return this.http.get<Company[]>(this.apiURL.getAllCompany)
    // .pipe(
    //   catchError(this.handleError('getAllCompany()', []))
    // );
  }
  getAllCompanyWithGstNo() {
    return this.http.get<Company[]>(this.apiURL.getAllCompanyWithGstNo)
    // .pipe(
    //   catchError(this.handleError('getAllCompany()', []))
    // );
  }
  getAllCompanyIdAndName() {
    return this.http.get<Company[]>(this.apiURL.getAllCompanyIdAndName)
      .pipe(
        catchError(this.handleError('getAllCompanyIdAndName()', []))
      );
  }
  getRouteByLoc(url: string, locCode: number[]) {
    return this.http.get<RouteList[]>(url + '/' + locCode)
  }
  getAllInventory() {
    return this.http.get<InventoryType[]>(this.apiURL.viewInventoryType)
    // .pipe(
    //   catchError(this.handleError('getAllInventory()', []))
    // );
  }
  getMatrixByInventory(url: string, inventoryCode: number[]) {
    return this.http.get<ProductMatrix[]>(url + '/' + inventoryCode)
  }
  getMatrixBySingleInventoryCode(url: string, inventoryCode: number[] | number) {
    return this.http.get<ProductMatrix[]>(url + '/' + inventoryCode)
  }
  getGroupByMatrix(url: string, matrixCode: number[]) {
    return this.http.get<ProductGroup[]>(url + '/' + matrixCode)
  }

  getSubGroupByGroup(url: string, groupId: number[]) {
    return this.http.get<ProductSubGroup[]>(url + '/' + groupId)
  }


  getProductBySubGroup(url: string, subGroupId: number[]) {
    return this.http.get<ProductDetails[]>(url + '/' + subGroupId)
  }

  getProductIdAndNameBySubGroupCodes(url: string, subGroupIds: number[]) {
    return this.http.get(url + '/' + subGroupIds)
  }

  getProductBySubGroupIdsAndLocIdWithPage(url: string, requestView: RequestView) {
    return this.http.post(url, requestView);
  }

  getAllParentLocations(url: string, companyCode: number) {
    return this.http.get<any[]>(url + '/' + companyCode)
    // .pipe(
    //   catchError(this.handleError('getAllParentLocations()', []))
    // );
  }

  getUserRolesByCompanyCode(url: string, companyCode: number) {
    return this.http.get(url + "/" + companyCode);
  }

  getAllEmployeeByLocation(url: string, locId: number) {
    return this.http.get<Employee[]>(url + '/' + locId)
    // .pipe(
    //   catchError(this.handleError('getAllEmployeeByLocation()', []))
    // );
  }

  getAllEmployeeByDepartment(url: string, departments: number[]) {
    let deptList = departments;
    let params = new HttpParams();
    params = params.append('department', deptList.join(', '));
    return this.http.get<string[]>(url, { params: params })
      .pipe(
        catchError(this.handleError('getAllEmployeeByDepartment()', []))
      );
  }
  getAllEmployeesByDeptCodes(url: string, deptCodes: number[]) {
    return this.http.get(url + "/" + deptCodes)
  }

  getAllVisitorByDepartment(url: string, department: number) {
    return this.http.get<VisitorVisit[]>(url + '/' + department)
    // .pipe(
    //   catchError(this.handleError('getAllVisitorByDepartment()', []))
    // );
  }

  getProductionInitalDataAndProductGroups(url: string, locationCode: number, inventoryType: number) {
    return this.http.get<Location[]>(url + '/' + locationCode + "/" + inventoryType)
      .pipe(
        catchError(this.handleError('getProductionInitalData()', []))
      );
  }
  getAllLocations(url: string, locationCode: number) {
    return this.http.get<any[]>(url + '/' + locationCode)
    // .pipe(
    //   catchError(this.handleError('getAllLocations()', []))
    // );
  }
  getAllLocationsByParentAndInv(url: string, locationCode: number, invCode: number) {
    return this.http.get<any[]>(url + '/' + locationCode + '/' + invCode);
  }
  getAllLocationsArray(url: string, locationCode: number[]) {
    return this.http.get<any[]>(url + '/' + locationCode)
    // .pipe(
    //   catchError(this.handleError('getAllLocations()', []))
    // );
  }

  getAllMasterLocationByCompany(companyRefNo: number) {
    return this.http.get<Location[]>(this.apiURL.getAlllocationByCompany + companyRefNo)
    // .pipe(
    //   catchError(this.handleError('getAllMasterLocationByCompany()', []))
    // );
  }

  getLocationsByCompanyCodes(url: String, companyCodes: number[]) {
    return this.http.get<Location[]>(url + "/" + companyCodes);
  }

  getLocationsByCompanyIds(companyRefNo: number[]) {
    return this.http.get<Location[]>(this.apiURL.getLocationsByCompanyIds + '/' + companyRefNo);
  }

  // getLocationsByParentLocCode(parentLocId: number) {
  //   return this.http.get<Location[]>(this.apiURL.getLocationsByparentLocationCode + "/" + parentLocId)
  //     .pipe(
  //       catchError(this.handleError('getLocationsByParentLocCode()', []))
  //     );
  // }
  //---------

  getAllCustomer() {
    return this.http.get<Customer[]>(this.apiURL.getAllCustomersIdAndName)
      .pipe(
        catchError(this.handleError('getAllCustomer()', []))
      );
  }

  getAllLedgerCustomer() {
    return this.http.get<Customer[]>(this.apiURL.getAllLedgerCustomersIdAndName);
  }

  getLocations(url: string) {
    return this.http.get<Location[]>(url)
    // .pipe(
    //   catchError(this.handleError('getAllLocations()', []))
    // );
  }

  //   () {
  //     return this.http.post<OrderReport[]>()
  //        .pipe(
  //          catchError(this.handleError('viewAllExecutiveReport()', []))
  //        );
  //  }

  viewAllExecutiveReport(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewExecutiveReports,
      obj
    );
  }

  viewHrExecutiveReport(obj: ViewReport): Observable<any> {
    return this.http.post(
      this.apiURL.viewHrExecutiveReports,
      obj
    );
  }

  //Hr Summary Report
  viewHrSummaryReport(obj: SummaryReport, reportType: string, frequency: string, module: string): Observable<any> {
    if (module == "Employee Attendance") {
      return this.getAttendances(obj, reportType, frequency);
    }
    if (module == "Leave") {
      return this.getLeaves(obj, reportType, frequency);
    }
    if (module == "Payroll") {
      return this.getSalaries(obj, reportType, frequency);
    }
    if (module == "Expense") {
      return this.getExpenses(obj, reportType, frequency);
    }
    if (module == "Loans") {
      return this.getLoans(obj, reportType, frequency);
    }
    if (module == "Food Coupons") {
      return this.getFoodCoupons(obj, reportType, frequency);
    }
    if (module == "Recruitment") {
      return this.getRecruitments(obj, reportType, frequency);
    }
  }

  getAttendances(obj: SummaryReport, reportType: string, frequency: string) {
    if (reportType == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewAttendanceSummaryReportByLocation,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyAttendanceSummaryReportByLocation,
        obj
      );
    }
    if (reportType == "By Department" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewAttendanceSummaryReportByDepartment,
        obj
      );
    }
    if (reportType == "By Department" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyAttendanceSummaryReportByDepartment,
        obj
      );
    }
    if (reportType == "By Employee" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewAttendanceSummaryReportByEmployee,
        obj
      );
    }
    if (reportType == "By Employee" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyAttendanceSummaryReportByEmployee,
        obj
      );
    }
  }

  getLeaves(obj: SummaryReport, reportType: string, frequency: string) {
    if (reportType == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewLeaveSummaryReportByLocation,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyLeaveSummaryReportByLocation,
        obj
      );
    }
    if (reportType == "By Department" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewLeaveSummaryReportByDepartment,
        obj
      );
    }
    if (reportType == "By Department" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyLeaveSummaryReportByDepartment,
        obj
      );
    }
    if (reportType == "By Employee" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewLeaveSummaryReportByEmployee,
        obj
      );
    }
    if (reportType == "By Employee" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyLeaveSummaryReportByEmployee,
        obj
      );
    }
  }

  getSalaries(obj: SummaryReport, reportType: string, frequency: string) {
    if (reportType == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewPayrollSummaryReportByLocation,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyPayrollSummaryReportByLocation,
        obj
      );
    }
    if (reportType == "By Department" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewPayrollSummaryReportByDepartment,
        obj
      );
    }
    if (reportType == "By Department" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyPayrollSummaryReportByDepartment,
        obj
      );
    }
    if (reportType == "By Employee" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewPayrollSummaryReportByEmployee,
        obj
      );
    }
    if (reportType == "By Employee" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyPayrollSummaryReportByEmployee,
        obj
      );
    }
  }

  getExpenses(obj: SummaryReport, reportType: string, frequency: string) {
    if (reportType == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewExpenseSummaryReportByLocation,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyExpenseSummaryReportByLocation,
        obj
      );
    }
    if (reportType == "By Department" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewExpenseSummaryReportByDepartment,
        obj
      );
    }
    if (reportType == "By Department" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyExpenseSummaryReportByDepartment,
        obj
      );
    }
    if (reportType == "By Employee" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewExpenseSummaryReportByEmployee,
        obj
      );
    }
    if (reportType == "By Employee" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyExpenseSummaryReportByEmployee,
        obj
      );
    }
  }

  getLoans(obj: SummaryReport, reportType: string, frequency: string) {
    if (reportType == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewLoanSummaryReportByLocation,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyLoanSummaryReportByLocation,
        obj
      );
    }
    if (reportType == "By Department" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewLoanSummaryReportByDepartment,
        obj
      );
    }
    if (reportType == "By Department" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyLoanSummaryReportByDepartment,
        obj
      );
    }
    if (reportType == "By Employee" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewLoanSummaryReportByEmployee,
        obj
      );
    }
    if (reportType == "By Employee" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyLoanSummaryReportByEmployee,
        obj
      );
    }
  }

  getFoodCoupons(obj: SummaryReport, reportType: string, frequency: string) {
    if (reportType == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewFoodCouponSummaryReportByLocation,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyFoodCouponSummaryReportByLocation,
        obj
      );
    }
    if (reportType == "By Department" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewFoodCouponSummaryReportByDepartment,
        obj
      );
    }
    if (reportType == "By Department" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyFoodCouponSummaryReportByDepartment,
        obj
      );
    }
    if (reportType == "By Employee" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewFoodCouponSummaryReportByEmployee,
        obj
      );
    }
    if (reportType == "By Employee" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyFoodCouponSummaryReportByEmployee,
        obj
      );
    }
  }

  getRecruitments(obj: SummaryReport, reportType: string, frequency: string) {
    if (reportType == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewRecruitmentSummaryReportByLocation,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyRecruitmentSummaryReportByLocation,
        obj
      );
    }
    if (reportType == "By Department" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewRecruitmentSummaryReportByDepartment,
        obj
      );
    }
    if (reportType == "By Department" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyRecruitmentSummaryReportByDepartment,
        obj
      );
    }
    if (reportType == "By Employee" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewRecruitmentSummaryReportByEmployee,
        obj
      );
    }
    if (reportType == "By Employee" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewMonthlyRecruitmentSummaryReportByEmployee,
        obj
      );
    }
  }

  //Summary OrderManagement Report
  viewAllSummaryReport(obj: SummaryReport, reportType: string, frequency: string, module: string): Observable<any> {
    if (module == "Order") {
      return this.orderStock(obj, reportType, frequency);
    }
    if (module == "Receives") {
      return this.receiveOrderStock(obj, reportType, frequency);
    }
    if (module == "Process") {
      return this.viewProcessOredr(obj, reportType, frequency);
    }
    if (module == "Dispatch") {
      return this.dispatchOrder(obj, reportType, frequency);
    }
    if (module == "Return") {
      return this.goodReturn(obj, reportType, frequency);
    }
    if (module == "Receive Returns") {
      return this.receiveGoodReturn(obj, reportType, frequency);
    }
    // if (module == "Process") {
    //   return this.processMakeToOrder(obj, reportType, frequency);
    // }
    // if (module == "Dispatch") {
    //   return this.dispatchMakeToOrder(obj, reportType, frequency);
    // }
  }
  orderStock(obj: SummaryReport, reportType: string, frequency: string) {
    if (reportType == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewSummaryReports,
        obj
      );
    }
    if (reportType == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewSummaryReportsMonthly,
        obj
      );
    }
    if (reportType == "By Group" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewSummaryReportsByGroup,
        obj
      );
    }
    if (reportType == "By Group" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewSummaryReportsByGroupMonthly,
        obj
      );
    }
    if (reportType == "By SubGroup" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewSummaryReportsBySubGroup,
        obj
      );
    }
    if (reportType == "By SubGroup" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewSummaryReportsBySubGroupMonthly,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewSummaryReportsByUser,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewSummaryReportsByUserMonthly,
        obj
      );
    }
    if (reportType == "By Route" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewSummaryReportsByRoute,
        obj
      );
    }
    if (reportType == "By Route" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewSummaryReportsByRouteMonthly,
        obj
      );
    }
    if (reportType == "By City" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewSummaryReportsByCity,
        obj
      );
    }
    if (reportType == "By City" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewSummaryReportsByCityMonthly,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewSummaryReportsByLocation,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewSummaryReportsByLocationMonthly,
        obj
      );
    }
  }
  viewProcessOredr(obj: SummaryReport, reportType: string, frequency: string) {
    if (reportType == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.processSummaryReports,
        obj
      );
    }
    if (reportType == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.processSummaryReportsMonthly,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.processSummaryReportsByUser,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.processSummaryReportsByUserMonthly,
        obj
      );
    }
    if (reportType == "By Route" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.processSummaryReportsByRoute,
        obj
      );
    }
    if (reportType == "By Route" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.processSummaryReportsByRouteMonthly,
        obj
      );
    }
    if (reportType == "By City" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.processSummaryReportsByCity,
        obj
      );
    }
    if (reportType == "By City" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.processSummaryReportsByCityMonthly,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.processSummaryReportsByLocation,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.processSummaryReportsByLocationMonthly,
        obj
      );
    }
  }
  dispatchOrder(obj: SummaryReport, reportType: string, frequency: string) {
    if (reportType == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.dispatchSummaryReports,
        obj
      );
    }
    if (reportType == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.dispatchSummaryReportsMonthly,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.dispatchSummaryReportsByUser,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.dispatchSummaryReportsByUserMonthly,
        obj
      );
    }
    if (reportType == "By Route" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.dispatchSummaryReportsByRoute,
        obj
      );
    }
    if (reportType == "By Route" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.dispatchSummaryReportsByRouteMonthly,
        obj
      );
    }
    if (reportType == "By City" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.dispatchSummaryReportsByCity,
        obj
      );
    }
    if (reportType == "By City" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.dispatchSummaryReportsByCityMonthly,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.dispatchSummaryReportsByLocation,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.dispatchSummaryReportsByLocationMonthly,
        obj
      );
    }
    if (reportType == "Monthly Dispatch (Sequence)") {
      return this.http.post(
        this.apiURL.dispatchSummaryReportsMonthlySequence,
        obj
      );
    }
    if (reportType == "Monthly Dispatch (Corresponding)") {
      return this.http.post(
        this.apiURL.dispatchSummaryReportsMonthlyCorresponding,
        obj
      );
    }
  }
  goodReturn(obj: SummaryReport, reportType: string, frequency: string) {
    if (reportType == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.goodReturnSummaryReports,
        obj
      );
    }
    if (reportType == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.goodReturnSummaryReportsMonthly,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.goodReturnSummaryReportsByUser,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.goodReturnSummaryReportsByUserMonthly,
        obj
      );
    }
    if (reportType == "By Route" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.goodReturnSummaryReportsByRoute,
        obj
      );
    }
    if (reportType == "By Route" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.goodReturnSummaryReportsByRouteMonthly,
        obj
      );
    }
    if (reportType == "By City" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.goodReturnSummaryReportsByCity,
        obj
      );
    }
    if (reportType == "By City" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.goodReturnSummaryReportsByCityMonthly,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.goodReturnSummaryReportsByLocation,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.goodReturnSummaryReportsByLocationMonthly,
        obj
      );
    }
  }
  receiveGoodReturn(obj: SummaryReport, reportType: string, frequency: string) {
    if (reportType == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.receiveReturnSummaryReports,
        obj
      );
    }
    if (reportType == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.receiveReturnSummaryReportsMonthly,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.receiveReturnSummaryReportsByUser,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.receiveReturnSummaryReportsByUserMonthly,
        obj
      );
    }
    if (reportType == "By Route" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.receiveReturnSummaryReportsByRoute,
        obj
      );
    }
    if (reportType == "By Route" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.receiveReturnSummaryReportsByRouteMonthly,
        obj
      );
    }
    if (reportType == "By City" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.receiveReturnSummaryReportsByCity,
        obj
      );
    }
    if (reportType == "By City" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.receiveReturnSummaryReportsByCityMonthly,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.receiveReturnSummaryReportsByLocation,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.receiveReturnSummaryReportsByLocationMonthly,
        obj
      );
    }
  }
  // processMakeToOrder(obj: SummaryReport, reportType: string, frequency: string) {
  //   if (reportType == "By Product" && frequency == "Date Range") {
  //     return this.http.post(
  //       this.apiURL.processMakeToOrderSummary,
  //       obj
  //     );
  //   }
  //   if (reportType == "By Product" && frequency == "Monthly") {
  //     return this.http.post(
  //       this.apiURL.processMakeToOrderSummaryMonthly,
  //       obj
  //     );
  //   }
  //   if (reportType == "By User" && frequency == "Date Range") {
  //     return this.http.post(
  //       this.apiURL.processMakeToOrderSummaryByUser,
  //       obj
  //     );
  //   }
  //   if (reportType == "By User" && frequency == "Monthly") {
  //     return this.http.post(
  //       this.apiURL.processMakeToOrderSummaryByUserMonthly,
  //       obj
  //     );
  //   }
  //   if (reportType == "By Route" && frequency == "Date Range") {
  //     return this.http.post(
  //       this.apiURL.processMakeToOrderSummaryByRoute,
  //       obj
  //     );
  //   }
  //   if (reportType == "By Route" && frequency == "Monthly") {
  //     return this.http.post(
  //       this.apiURL.processMakeToOrderSummaryByRouteMonthly,
  //       obj
  //     );
  //   }
  //   if (reportType == "By City" && frequency == "Date Range") {
  //     return this.http.post(
  //       this.apiURL.processMakeToOrderSummaryByCity,
  //       obj
  //     );
  //   }
  //   if (reportType == "By City" && frequency == "Monthly") {
  //     return this.http.post(
  //       this.apiURL.processMakeToOrderSummaryByCityMonthly,
  //       obj
  //     );
  //   }
  //   if (reportType == "By Location" && frequency == "Date Range") {
  //     return this.http.post(
  //       this.apiURL.processMakeToOrderSummaryByLocation,
  //       obj
  //     );
  //   }
  //   if (reportType == "By Location" && frequency == "Monthly") {
  //     return this.http.post(
  //       this.apiURL.processMakeToOrderSummaryByLocationMonthly,
  //       obj
  //     );
  //   }
  // }
  // dispatchMakeToOrder(obj: SummaryReport, reportType: string, frequency: string) {
  //   if (reportType == "By Product" && frequency == "Date Range") {
  //     return this.http.post(
  //       this.apiURL.dispatchMakeToOrderSummary,
  //       obj
  //     );
  //   }
  //   if (reportType == "By Product" && frequency == "Monthly") {
  //     return this.http.post(
  //       this.apiURL.dispatchMakeToOrderSummaryMonthly,
  //       obj
  //     );
  //   }
  //   if (reportType == "By User" && frequency == "Date Range") {
  //     return this.http.post(
  //       this.apiURL.dispatchMakeToOrderSummaryByUser,
  //       obj
  //     );
  //   }
  //   if (reportType == "By User" && frequency == "Monthly") {
  //     return this.http.post(
  //       this.apiURL.dispatchMakeToOrderSummaryByUserMonthly,
  //       obj
  //     );
  //   }
  //   if (reportType == "By Route" && frequency == "Date Range") {
  //     return this.http.post(
  //       this.apiURL.dispatchMakeToOrderSummaryByRoute,
  //       obj
  //     );
  //   }
  //   if (reportType == "By Route" && frequency == "Monthly") {
  //     return this.http.post(
  //       this.apiURL.dispatchMakeToOrderSummaryByRouteMonthly,
  //       obj
  //     );
  //   }
  //   if (reportType == "By City" && frequency == "Date Range") {
  //     return this.http.post(
  //       this.apiURL.dispatchMakeToOrderSummaryByCity,
  //       obj
  //     );
  //   }
  //   if (reportType == "By City" && frequency == "Monthly") {
  //     return this.http.post(
  //       this.apiURL.dispatchMakeToOrderSummaryByCityMonthly,
  //       obj
  //     );
  //   }
  //   if (reportType == "By Location" && frequency == "Date Range") {
  //     return this.http.post(
  //       this.apiURL.dispatchMakeToOrderSummaryByLocation,
  //       obj
  //     );
  //   }
  //   if (reportType == "By Location" && frequency == "Monthly") {
  //     return this.http.post(
  //       this.apiURL.dispatchMakeToOrderSummaryByLocationMonthly,
  //       obj
  //     );
  //   }
  // }
  receiveOrderStock(obj: SummaryReport, reportType: string, frequency: string) {
    if (reportType == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.receiveOrderStockSummary,
        obj
      );
    }
    if (reportType == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.receiveOrderStockSummaryMonthly,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.receiveOrderStockSummaryByUser,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.receiveOrderStockSummaryByUserMonthly,
        obj
      );
    }
    if (reportType == "By Route" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.receiveOrderStockSummaryByRoute,
        obj
      );
    }
    if (reportType == "By Route" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.receiveOrderStockSummaryByRouteMonthly,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.receiveOrderStockSummaryByLocation,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.receiveOrderStockSummaryByLocationMonthly,
        obj
      );
    }
    if (reportType == "By City" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.receiveOrderStockSummaryByCity,
        obj
      );
    }
    if (reportType == "By City" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.receiveOrderStockSummaryByCityMonthly,
        obj
      );
    }
  }
  //Summary Sale Report
  getAllCustomerClass() {
    return this.http.get<CustomerClass[]>(this.apiURL.getAllCustomerClass)
      .pipe(
        catchError(this.handleError('getAllCustomerClass()', []))
      );
  }
  getAllOrganiser(loginLocation: number) {
    return this.http.get<Organiser[]>(this.apiURL.getAllOrganiserList + loginLocation)
      .pipe(
        catchError(this.handleError('getAllOrganiser()', []))
      );
  }
  getOrganiserDetailsByOrganiser(url: string, organiserCode: number[]) {
    return this.http.get<OrganiserDetail[]>(url + organiserCode)
  }
  viewAllSummarySaleReport(obj: SummaryReportSale, reportTypeName: string, frequency: string): Observable<any> {
    if (reportTypeName == "By City" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewSummarySaleReportsByCity,
        obj
      );
    }
    if (reportTypeName == "By City" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewSummarySaleReportsByCityMonthly,
        obj
      );
    }
    if (reportTypeName == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewSummarySaleReportsByLocation,
        obj
      );
    }
    if (reportTypeName == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewSummarySaleReportsByLocationMonthly,
        obj
      );
    }
    if (reportTypeName == "By Customer Class" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewSummarySaleReportsByCustClass,
        obj
      );
    }
    if (reportTypeName == "By Customer Class" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewSummarySaleReportsByCustClassMonthly,
        obj
      );
    }
    if (reportTypeName == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewSummarySaleReportsByUser,
        obj
      );
    }
    if (reportTypeName == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewSummarySaleReportsByUserMonthly,
        obj
      );
    }
    if (reportTypeName == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewSummarySaleReportsByProduct,
        obj
      );
    }
    if (reportTypeName == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewSummarySaleReportsByProductMonthly,
        obj
      );
    }
    if (reportTypeName == "By Organiser Detail" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewSummarySaleReportsByOrganiser,
        obj
      );
    }
    if (reportTypeName == "By Organiser Detail" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewSummarySaleReportsByOrganiserMonthly,
        obj
      );
    }
  }

  viewAllSummaryGstReport(obj: SummaryReportGst, reportTypeName: string, frequency: string): Observable<any> {
    if (reportTypeName == "By City" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewSummaryGstReportsByCity,
        obj
      );
    }
    if (reportTypeName == "By City" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewSummaryGstReportsByCityMonthly,
        obj
      );
    }
    if (reportTypeName == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewSummaryGstReportsByLocation,
        obj
      );
    }
    if (reportTypeName == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewSummaryGstReportsByLocationMonthly,
        obj
      );
    }
    if (reportTypeName == "By Customer Class" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewSummaryGstReportsByCustClass,
        obj
      );
    }
    if (reportTypeName == "By Customer Class" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewSummaryGstReportsByCustClassMonthly,
        obj
      );
    }
    if (reportTypeName == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewSummaryGstReportsByUser,
        obj
      );
    }
    if (reportTypeName == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewSummaryGstReportsByUserMonthly,
        obj
      );
    }
    if (reportTypeName == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewSummaryGstReportsByProduct,
        obj
      );
    }
    if (reportTypeName == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewSummaryGstReportsByProductMonthly,
        obj
      );
    }
    if (reportTypeName == "By Organiser Detail" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.viewSummaryGstReportsByOrganiser,
        obj
      );
    }
    if (reportTypeName == "By Organiser Detail" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.viewSummaryGstReportsByOrganiserMonthly,
        obj
      );
    }
  }




  //Summary Make to Order Report
  viewSummaryMaketoOrderReport(obj: SummaryMaketoOrder, reportType: string, frequency: string, module: string): Observable<any> {
    if (module == "Order") {
      return this.createOrder(obj, reportType, frequency);
    }
    if (module == "Receives") {
      return this.receiveMakeToOrder(obj, reportType, frequency);
    }
    if (module == "Bill") {
      return this.bill(obj, reportType, frequency);
    }
    if (module == "Return") {
      return this.returnMakeToOrder(obj, reportType, frequency);
    }
    if (module == "Process") {
      return this.processMakeToOrder(obj, reportType, frequency);
    }
    if (module == "Dispatch") {
      return this.dispatchMakeToOrder(obj, reportType, frequency);
    }
    if (module == "Receive Returns") {
      return this.receiveReturnMakeToOrder(obj, reportType, frequency);
    }
  }
  createOrder(obj: SummaryMaketoOrder, reportType: string, frequency: string) {
    if (reportType == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.createMakeToOrderSummary,
        obj
      );
    }
    if (reportType == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.createMakeToOrderSummaryMonthly,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.createMakeToOrderSummaryByUser,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.createMakeToOrderSummaryByUserMonthly,
        obj
      );
    }
  }
  receiveMakeToOrder(obj: SummaryMaketoOrder, reportType: string, frequency: string) {
    if (reportType == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.receiveMakeToOrderSummary,
        obj
      );
    }
    if (reportType == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.receiveMakeToOrderSummaryMonthly,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.receiveMakeToOrderSummaryByUser,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.receiveMakeToOrderSummaryByUserMonthly,
        obj
      );
    }
  }
  bill(obj: SummaryMaketoOrder, reportType: string, frequency: string) {
    if (reportType == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.billMakeToOrderSummary,
        obj
      );
    }
    if (reportType == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.billMakeToOrderSummaryMonthly,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.billMakeToOrderSummaryByUser,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.billMakeToOrderSummaryByUserMonthly,
        obj
      );
    }
  }
  returnMakeToOrder(obj: SummaryMaketoOrder, reportType: string, frequency: string) {
    if (reportType == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.returnMakeToOrderSummary,
        obj
      );
    }
    if (reportType == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.returnMakeToOrderSummaryMonthly,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.returnMakeToOrderSummaryByUser,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.returnMakeToOrderSummaryByUserMonthly,
        obj
      );
    }
  }

  processMakeToOrder(obj: SummaryMaketoOrder, reportType: string, frequency: string) {
    if (reportType == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.processMakeToOrderSummary,
        obj
      );
    }
    if (reportType == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.processMakeToOrderSummaryMonthly,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.processMakeToOrderSummaryByUser,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.processMakeToOrderSummaryByUserMonthly,
        obj
      );
    }
    if (reportType == "By Route" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.processMakeToOrderSummaryByRoute,
        obj
      );
    }
    if (reportType == "By Route" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.processMakeToOrderSummaryByRouteMonthly,
        obj
      );
    }
    if (reportType == "By City" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.processMakeToOrderSummaryByCity,
        obj
      );
    }
    if (reportType == "By City" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.processMakeToOrderSummaryByCityMonthly,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.processMakeToOrderSummaryByLocation,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.processMakeToOrderSummaryByLocationMonthly,
        obj
      );
    }
  }

  dispatchMakeToOrder(obj: SummaryMaketoOrder, reportType: string, frequency: string) {
    if (reportType == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.dispatchMakeToOrderSummary,
        obj
      );
    }
    if (reportType == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.dispatchMakeToOrderSummaryMonthly,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.dispatchMakeToOrderSummaryByUser,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.dispatchMakeToOrderSummaryByUserMonthly,
        obj
      );
    }
    if (reportType == "By Route" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.dispatchMakeToOrderSummaryByRoute,
        obj
      );
    }
    if (reportType == "By Route" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.dispatchMakeToOrderSummaryByRouteMonthly,
        obj
      );
    }
    if (reportType == "By City" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.dispatchMakeToOrderSummaryByCity,
        obj
      );
    }
    if (reportType == "By City" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.dispatchMakeToOrderSummaryByCityMonthly,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.dispatchMakeToOrderSummaryByLocation,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.dispatchMakeToOrderSummaryByLocationMonthly,
        obj
      );
    }
  }

  receiveReturnMakeToOrder(obj: SummaryMaketoOrder, reportType: string, frequency: string) {
    if (reportType == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.receiveReturnsMakeToOrderSummaryByProduct,
        obj
      );
    }
    if (reportType == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.receiveReturnsMakeToOrderSummaryByProductMonthly,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.receiveReturnsMakeToOrderSummaryByUser,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.receiveReturnsMakeToOrderSummaryByUserMonthly,
        obj
      );
    }
  }
  //Summary Inventory Report
  viewSummaryInventoryReport(obj: SummaryInventoryReport, reportType: string, frequency: string, module: string): Observable<any> {
    if (module == "Wastage") {
      return this.wastage(obj, reportType, frequency);
    }
    if (module == "Indent") {
      return this.indentStock(obj, reportType, frequency);
    }
    if (module == "Issue") {
      return this.issueStock(obj, reportType, frequency);
    }
    if (module == "Receive") {
      return this.receiveStock(obj, reportType, frequency);
    }
  }
  wastage(obj: SummaryInventoryReport, reportType: string, frequency: string) {
    if (reportType == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.wastageSummary,
        obj
      );
    }
    if (reportType == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.wastageSummaryMonthly,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.wastageSummaryByUser,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.wastageSummaryByUserMonthly,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.wastageSummaryByLocation,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.wastageSummaryByLocationMonthly,
        obj
      );
    }
  }
  indentStock(obj: SummaryInventoryReport, reportType: string, frequency: string) {
    if (reportType == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.indentStockSummary,
        obj
      );
    }
    if (reportType == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.indentStockSummaryMonthly,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.indentStockSummaryByUser,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.indentStockSummaryByUserMonthly,
        obj
      );
    }
    if (reportType == "By Department" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.indentStockSummaryByDept,
        obj
      );
    }
    if (reportType == "By Department" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.indentStockSummaryByDeptMonthly,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.indentStockSummaryByLocation,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.indentStockSummaryByLocationMonthly,
        obj
      );
    }
  }
  issueStock(obj: SummaryInventoryReport, reportType: string, frequency: string) {
    if (reportType == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.issueStockSummary,
        obj
      );
    }
    if (reportType == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.issueStockSummaryMonthly,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.issueStockSummaryByUser,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.issueStockSummaryByUserMonthly,
        obj
      );
    }
    if (reportType == "By Department" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.issueStockSummaryByDept,
        obj
      );
    }
    if (reportType == "By Department" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.issueStockSummaryByDeptMonthly,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.issueStockSummaryByLocation,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.issueStockSummaryByLocationMonthly,
        obj
      );
    }
  }
  receiveStock(obj: SummaryInventoryReport, reportType: string, frequency: string) {
    if (reportType == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.receiveStockSummary,
        obj
      );
    }
    if (reportType == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.receiveStockSummaryMonthly,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.receiveStockSummaryByUser,
        obj
      );
    }
    if (reportType == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.receiveStockSummaryByUserMonthly,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.receiveStockSummaryByLocation,
        obj
      );
    }
    if (reportType == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.receiveStockSummaryByLocationMonthly,
        obj
      );
    }
  }
  //Summary Production Report
  viewSummaryProduction(obj: SummaryProduction, reportTypeName: string, frequency: string): Observable<any> {
    if (reportTypeName == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.productionSummaryByLocation,
        obj
      );
    }
    if (reportTypeName == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.productionSummaryByLocationMonthly,
        obj
      );
    }
    if (reportTypeName == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.productionSummaryByUser,
        obj
      );
    }
    if (reportTypeName == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.productionSummaryByUserMonthly,
        obj
      );
    }
    if (reportTypeName == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.productionSummaryByProduct,
        obj
      );
    }
    if (reportTypeName == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.productionSummaryByProductMonthly,
        obj
      );
    }
    if (reportTypeName == "By Employee" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.productionSummaryByEmp,
        obj
      );
    }
    if (reportTypeName == "By Employee" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.productionSummaryByEmpMonthly,
        obj
      );
    }
  }
  //Summary Purchase Report
  viewSummaryPurchase(obj: SummaryPurchase, reportTypeName: string, frequency: string): Observable<any> {
    if (reportTypeName == "By Location" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.purchaseSummaryByLocation,
        obj
      );
    }
    if (reportTypeName == "By Location" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.purchaseSummaryByLocationMonthly,
        obj
      );
    }
    if (reportTypeName == "By User" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.purchaseSummaryByUser,
        obj
      );
    }
    if (reportTypeName == "By User" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.purchaseSummaryByUserMonthly,
        obj
      );
    }
    if (reportTypeName == "By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.purchaseSummaryByProduct,
        obj
      );
    }
    if (reportTypeName == "By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.purchaseSummaryByProductMonthly,
        obj
      );
    }
    if (reportTypeName == "By Supplier" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.purchaseSummaryBySupplier,
        obj
      );
    }
    if (reportTypeName == "By Supplier" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.purchaseSummaryBySupplierMonthly,
        obj
      );
    }
  }
  //Summary Festival Coupon Report
  viewSummaryFestivalCoupons(obj: SummaryFestivalCouponReport, reportTypeName: string, frequency: string): Observable<any> {
    if (reportTypeName == "Redemption By Coupon" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.festivalCouponSummaryByCoupon,
        obj
      );
    }
    if (reportTypeName == "Redemption By Coupon" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.festivalCouponSummaryByCouponMonthly,
        obj
      );
    }
    if (reportTypeName == "Redemption By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.festivalCouponSummaryByProduct,
        obj
      );
    }
    if (reportTypeName == "Redemption By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.festivalCouponSummaryByProductMonthly,
        obj
      );
    }
    if (reportTypeName == "Redemption Slotwise By Coupon" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.festivalCouponSummaryByCouponSlotWise,
        obj
      );
    }
    if (reportTypeName == "Redemption Slotwise By Coupon" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.festivalCouponSummaryByCouponSlotWiseMonthly,
        obj
      );
    }
    if (reportTypeName == "Redemption Slotwise By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.festivalCouponSummaryByProductSlotWise,
        obj
      );
    }
    if (reportTypeName == "Redemption Slotwise By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.festivalCouponSummaryByProductSlotWiseMonthly,
        obj
      );
    }
    if (reportTypeName == "Category By Volume" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.festivalCouponSummaryCategoryByVolume,
        obj
      );
    }
    if (reportTypeName == "Category By Volume" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.festivalCouponSummaryCategoryByVolumeMonthly,
        obj
      );
    }
    if (reportTypeName == "Category By Product" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.festivalCouponSummaryCategoryByProduct,
        obj
      );
    }
    if (reportTypeName == "Category By Product" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.festivalCouponSummaryCategoryByProductMonthly,
        obj
      );
    }
  }

  searchProduct(url: string, productName: string) {
    return this.http.get<ProductDetails[]>(url + productName)
  }
  viewOrderDetails(obj: ViewReport): Observable<any> {
    return this.http.post(
      this.apiURL.viewOrderDetails,
      obj

    );
  }
  viewOrderByRouteDetails(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewOrderByRouteDetails,
      obj

    );
  }

  viewOrderByCityDetails(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewOrderByCityDetails,
      obj

    );
  }

  viewOrderByGroupDetails(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewOrderByGroupDetails,
      obj

    );
  }

  viewTop10ProductDetails(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewTop10ProductDetails,
      obj

    );
  }

  viewBottom10ProductDetails(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewBottom10ProductDetails,
      obj

    );
  }

  viewTop10LocationDetails(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewTop10LocationDetails,
      obj

    );
  }

  viewBottom10LocationDetails(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewBottom10LocationDetails,
      obj

    );
  }

  viewReturnByLocationDetails(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewReturnByLocationDetails,
      obj

    );
  }

  viewDiscrepencyByLocationDetails(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewDiscrepencyByLocationDetails,
      obj

    );
  }

  viewTop10ReturnProductDetails(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewTop10ReturnProductDetails,
      obj

    );
  }

  viewOrderTypeDetails(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewOrderTypeDetails,
      obj

    );
  }

  viewOrderByDateDetails(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewOrderByDateDetails,
      obj

    );
  }

  viewOrderByTimeDetails(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewOrderByTimeDetails,
      obj

    );
  }

  viewOrderByCityAndMatrixDetails(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewOrderByCityAndMatrixDetails,
      obj

    );
  }


  viewDispatchDetails(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewDispatchDetails,
      obj

    )
  }

  viewReturnDetails(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewReturnDetails,
      obj

    );
  }

  viewAllMakeToOrderReport(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewMakeToOrderReports,
      obj

    );
  }

  viewAllSalesReport(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewSalesReports,
      obj

    );
  }

  viewAllPurchaseReport(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewPurchaseReports,
      obj

    );
  }

  viewAllProductionReport(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewProductionReports,
      obj

    );
  }

  viewAllInventoryReport(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewInventoryReports,
      obj

    );
  }
  viewAllGstReport(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewGstReports,
      obj

    );
  }

  // getColumnChartFormat(columns: string[], inputData: object[]): object[][] {
  //   let output: object[][] = [];
  //   inputData.forEach((element, index) => {
  //     let zeroArray = [];
  //     zeroArray.push(0);
  //     inputData.forEach((element) => {
  //       zeroArray.push(0);
  //     });
  //     zeroArray[0] = element[0];
  //     zeroArray[index + 1] = element[1];
  //     output.push(zeroArray);
  //     columns.push(element[0]);
  //   });
  //   return output;
  // }

  getColumnChartFormat(columns: string[], inputData: any[]): any[][] {
    let output: any[][] = [];

    inputData.forEach((element, index) => {
      // Start row with first value as city name
      let row: any[] = [element[0]];

      // Fill rest with nulls
      for (let i = 0; i < inputData.length; i++) {
        row.push(null);
      }

      // Place the actual value in correct column
      row[index + 1] = element[1];

      output.push(row);

      // Add column name (city) once
      columns.push(element[0]);
    });

    return output;
  }

  getAllLocation() {
    return this.http.get<Location[]>(this.apiURL.getAlllocation)
      .pipe(
        catchError(this.handleError('getAllLocation()', []))
      );

  }
  getHSNWiseGSTReport(obj: getGSTReportsParam): Observable<any> {
    return this.http.post(
      this.apiURL.getHSNWiseAndPeriodWiseGstReport,
      obj

    );
  }
  getTaxRateWiseTaxReport(obj: getGSTReportsParam): Observable<any> {
    return this.http.post(
      this.apiURL.getTaxRateWiseTaxReport,
      obj

    );
  }
  getCustomerWiseTaxReport(obj: getGSTReportsParam): Observable<any> {
    return this.http.post(
      this.apiURL.getCustomerWiseTaxReport,
      obj

    );
  }
  getSupplierWiseTaxReport(obj: getGSTReportsParam): Observable<any> {
    return this.http.post(
      this.apiURL.getSupplierWiseTaxReport,
      obj

    );
  }
  getReverseChargeTaxReport(obj: getGSTReportsParam): Observable<any> {
    return this.http.post(
      this.apiURL.getReverseChargeTaxReport,
      obj

    );
  }
  getITCTaxReport(obj: getGSTReportsParam): Observable<any> {
    return this.http.post(
      this.apiURL.getITCTaxReport,
      obj

    );
  }
  getTransactionLogs(obj: getGSTReportsParam): Observable<any> {
    return this.http.post(
      this.apiURL.getTransactionLogs,
      obj

    );
  }

  getMonthWiseGstReport(obj: getGSTReportsParam): Observable<any> {
    return this.http.post(
      this.apiURL.getMonthWiseGstReport,
      obj

    );
  }
  getOrderProductsforProduction(obj: ViewReport): Observable<any> {
    return this.http.post(
      this.apiURL.getOrderProductsforProduction,
      obj

    );
  }
  ///////////////////////////
  //New API CALL fro Make To Order
  ///////////////////////////////
  getSetupGroupsHavingProductsByCompanyIdAndType(companyCode: number, type: string) {
    return this.http.get<ProductGroup[]>(this.apiURL.getSetupGroupsHavingProductsByCompanyIdAndType + "/" + companyCode + "/" + type)
    // .pipe(
    //   catchError(this.handleError('getSetupGroupsHavingProductsByCompanyIdAndType()', []))
    // );
  }
  getProductSubGroupByProductGroupId(groupId: number) {
    return this.http.get<ProductSubGroup[]>(this.apiURL.getSubGroupByGroupCode + '/' + groupId)
    // .pipe(
    //   catchError(this.handleError('getProductSubGroupByProductGroupId()', []))
    // );
  }
  getProductDetailsMinDataBySubGroupId(subGroupId: number) {

    return this.http.get<ProductDetail[]>(this.apiURL.getProductDetailsMinDataByProductSubGroupId + '/' + subGroupId)
    // .pipe(
    //   catchError(this.handleError('getProductDetailsBySubGroupId', []))
    // );
  }
  getProductColor() {
    return this.http.get<ProductColors[]>(this.apiURL.getProductColor)
      .pipe(
        catchError(this.handleError('getProductColor()', []))
      );
  }
  getProductComposition() {
    return this.http.get<ProductComposition[]>(this.apiURL.getCompositionNames)
      .pipe(
        catchError(this.handleError('getProductComposition()', []))
      );
  }
  getProductShape() {
    return this.http.get<ProductShape[]>(this.apiURL.getProductShape)
      .pipe(
        catchError(this.handleError('getProductComposition()', []))
      );
  }
  ///////////////////////////////GET ASSETS NAME ////////////////////////////////////
  getAllAssetNames(loc: number) {
    return this.http.get<AssetsName[]>(this.apiURL.getassetsIdAndNameByCompanyCode + "/" + loc)
      .pipe(
        catchError(this.handleError('getAllAssetNames()', []))
      );
  }
  ///////////////////////////////GET ASSETS NAME ////////////////////////////////////


  getAllDispatchNoByLocIDFromDateToDate(locId: String, fromdate: String, toDate: String): Observable<any> {
    return this.http.get<AssetsName[]>(this.apiURL.getAllDispatchNoByLocIDFromDateToDate + "/" + locId + "/" + fromdate + "/" + toDate)
    // .pipe(
    //   catchError(this.handleError('getAllAssetNames()', []))
    // );
  }

  //Export Data to CSV
  exportHeaders(url: string, exportType: string, module: string, req: any) {
    return this.http.post(url + "/" + exportType + "/" + module, req, { responseType: 'arraybuffer' }).pipe(
      catchError(this.handleError('exportHeaders()', []))
    );
  }

  insertErrorLog(url: string, errorLog: ErrorLog) {
    return this.http.post(
      url, errorLog,
      { responseType: 'json' })
  }

  getAllStates(url: string) {
    return this.http.get(url);
  }

  getAllDistrictsByStateCode(url: string, stateCode: number) {
    return this.http.get(url + '/' + stateCode);
  }

  getlocationscodeByparentLocation(url: string, locId: number) {
    return this.http.get<Location[]>(url + '/' + locId)
    // .pipe(
    //   catchError(this.handleError('getlocationscodeByparentLocation()', []))
    // );
  }

  getLocationsByParentCodes(url: string, parentCode: number[]) {
    return this.http.get(url + "/" + parentCode);
  }

  getIntraLocationsByCompanyCode(url: string, parentCompanyCode: number) {
    return this.http.get(url + "/" + parentCompanyCode);
  }


  checkModuleAccessAndOperation(internalName: string, fromModule: string, refNo: string) {
    return this.http.get(this.apiURL.checkModuleAccessAndOperation + "/" + internalName + "/" + fromModule + "/" + refNo);
  }

  checkModuleAccessAndOperationForReceive(internalName: string, fromModule: string, refNo: string, saleNo: string) {
    return this.http.get(this.apiURL.checkModuleAccessAndOperation + "/" + internalName + "/" + fromModule + "/" + refNo + "/" + saleNo);
  }


  getSummaryLocationReport(obj: SummaryReport) {
    return this.http.post(this.apiURL.getSummaryLocationReport, obj);
  }

  getSummaryAccountsAgingReport(obj: SummaryReport, reportName: string) {

    if (reportName == "By Location") {
      return this.http.post(this.apiURL.getSummaryAgeingReport, obj);
    } else if (reportName == "By Employee" || reportName == "By Supplier") {
      return this.http.post(this.apiURL.getSummaryAgeingReportLedgers, obj);
    }

  }

  getReconciliationReport(url: string, obj: SummaryReport) {
    return this.http.post(url, obj);
  }

  getGoodsReturnNoByLocAndInvAndDate(url: string, requestView: RequestView) {
    return this.http.post(url, requestView).pipe(
      catchError(this.handleError('getGoodsReturnNoByLocAndInvAndDate()', []))
    );
  }

  getGoodsReturnNoByLocAndInventory(url: string, locCode: number, inventoryId: number, returnNo: string) {
    return this.http.get(url + "/" + locCode + "/" + inventoryId + "/" + returnNo).pipe(
      catchError(this.handleError('getGoodsReturnNoByLocAndInventory()', []))
    );
  }

  getGoodsReturnByReturnNo(url: string, returnNo: string) {
    return this.http.get(url + "/" + returnNo)
      .pipe(
        catchError(this.handleError('getGoodsReturnByReturnNo()', []))
      );
  }

  getProductOffersByProductAndLoc(url: string, productId: number, locCode: number) {
    return this.http.get<any>(url + productId + '/' + locCode);
  }

  viewAllSummaryStoreReportingReport(obj: DetailStoreReporting, reportTypeName: string): Observable<any> {
    if (reportTypeName == "By Store") {
      return this.http.post(
        this.apiURL.summaryViewStoreReporting,
        obj
      );
    }
    if (reportTypeName == "By Supervisor") {
      return this.http.post(
        this.apiURL.summaryViewSupervisorReporting,
        obj
      );
    }
    if (reportTypeName == "By Executive") {
      return this.http.post(
        this.apiURL.summaryViewStaffReporting,
        obj
      );
    }
  }

  getEditTrailReport(obj: RequestView): Observable<any> {
    return this.http.post(
      this.apiURL.getEditTrailReport,
      obj

    );
  }

  //new added
  getCouponProductsRequiredQty(url: string, locationCode: number) {
    return this.http.get(url + '/' + locationCode);
  }
  getCouponProductsRequiredQtyBySetup(url: string, setupCodes: number[], locationCode: number) {
    return this.http.get(url + '/' + setupCodes + '/' + locationCode);
  }

  saveStoreSetUp(url: string, obj: WebOrderStoreSetup[]) {
    return this.http.post<any>(
      url,
      obj
    );
  }

  getStorePickupAllowLocations(url: string, locationCode: number, selectedUrl: string) {
    return this.http.get<any[]>(url + '/' + locationCode + '/' + selectedUrl)
  }

  getCouponHistoryByLoginLocation(url: string, locId: number) {
    return this.http.get<Location[]>(url + '/' + locId)
  }

  getFranchaiseEnquirys(url: string, obj: RequestView): Observable<any> {
    return this.http.post<any>(url, obj);
  }

  insertWebOrderProductQtySetUp(url: string, value: WebOrderAllowProductDto) {
    return this.http.post<any>(
      url,
      value,
      { responseType: 'json' }
    );
  }

  //Summary Spin And Win Report
  viewSummarySpinAndWinReport(obj: SummaryFestivalCouponReport, reportTypeName: string, frequency: string): Observable<any> {
    if (reportTypeName == "Redemption By Spin N Win" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.spinAndWinSummaryReport,
        obj
      );
    }
    if (reportTypeName == "Redemption By Spin N Win" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.spinAndWinSummaryReportMonthly,
        obj
      );
    }
    if (reportTypeName == "Redemption By Slotwise Spin N Win" && frequency == "Date Range") {
      return this.http.post(
        this.apiURL.spinAndWinSlotwiseSummaryReport,
        obj
      );
    }
    if (reportTypeName == "Redemption By Slotwise Spin N Win" && frequency == "Monthly") {
      return this.http.post(
        this.apiURL.spinAndWinSlotwiseSummaryReportMonthly,
        obj
      );
    }
  }

  viewMessageCenterExecutiveReport(obj: ViewReport): Observable<any> {

    return this.http.post(
      this.apiURL.viewMessageCenterExecutiveReports,
      obj
    );
  }

  stopNotification(url: string, userId: string, module: string, refNo: string, app: string) {
    return this.http.get<any>(url + '/' + userId + '/' + module + '/' + refNo + '/' + app)
  }

  insertBulkEntry(url: string, formControl: UntypedFormGroup) {
    return this.http.post(
      url, formControl,
      { responseType: 'json' })
  }

  getCustomerListByCustomerCodes(url: string, customerCodes: string[]) {
    return this.http.get(url + '/' + customerCodes)
  }

  getRestaurantLocationSetupByCompanyCodeAndParentLoc(url: string, companyCode: number, parentLoc: number) {
    return this.http.get<any[]>(url + '/' + companyCode + "/" + parentLoc)
  }

  getRestaurantAggregaotorSetupByCompanyCodeAndAggregator(url: string, companyCode: number, aggregator: string) {
    return this.http.get<any[]>(url + '/' + companyCode + "/" + aggregator)
  }

  getSubModulesByModuleCode(url: string, moduleCode: number[]) {
    console.log(url)
    return this.http.get<any>(url + '/' + moduleCode)
  }

  insertSubscriptionPlan(url: string, subscriptionPlan: SubscriptionPlan) {
    return this.http.post(url, subscriptionPlan)
  }

  getPackages(url: string, packageName: string) {
    return this.http.get(url + "/" + packageName)
  }

  getInvoiceNoByCustomerCode(url: String, custCode: string) {
    return this.http.get<Location[]>(url + "/" + custCode);
  }

  checkCustSubscriptionExistOrNot(url: String, custCode: string, packageCode: string) {
    return this.http.get<any>(url + "/" + custCode + "/" + packageCode);
  }

  getClientDataByCustomerCode(url: String, custCode: string) {
    return this.http.get<any>(url + "/" + custCode);
  }

  getSubscriptionServiceBalanceByCustomerCodeAndPackageCode(url: String, custCode: string, packagecode: string) {
    return this.http.get<Location[]>(url + "/" + custCode + "/" + packagecode);
  }

  checkPackageSetupExistOrNot(url: String, productId: number) {
    return this.http.get<any>(url + "/" + productId);
  }
}